export const GET_PRODUCION_PLANNING_DATA = "GET_PRODUCION_PLANNING_DATA";

export const GET_HARVEST_FORECAST_REQUEST = 'GET_HARVEST_FORECAST_REQUEST';
export const GET_HARVEST_FORECAST_SUCCESS = 'GET_HARVEST_FORECAST_SUCCESS';
export const GET_HARVEST_FORECAST_FAILURE = 'GET_HARVEST_FORECAST_FAILURE';
